import React from "react";
import { Button} from "antd";
import Table from 'atoms/Table';
import styled from "@emotion/styled";
import { getRoleList } from "redux/selectors";
import { connect } from "react-redux";

const StyledButton = styled(Button)`
  background-color: #00685F;
  border-radius: 5px;
  color: #FFFFFF !important;
  width: 100px;
  ${'' /* font-weight: bold; */}
  &:hover {   background-color: #00685F;
  border-color: #00685F;
  color: #ffffff !important;
`;
const StyledButtonCancel = styled(Button)`
  width: 125px;
  color: white;
  background-color: #ffffff;
  border-radius: 5px;
  margin-left: 5%;
  border-color: #000000;
  color: #000000 !important;
  &:hover {   background-color: #ffffff;
  border-color: #000000;
  color: #000000 !important;
  }

`;
const StyledButtons = styled(Button)`
  background-color: #26A4FF;
  border-radius: 5px;
  color: #FFFFFF;
  width: 150px;
  font-weight: bold;
`;
const SelectTable = ({
  step,
  setStep,
  columns,
  tabledata,
  submit,
  setCreate,
  setOpenModal,
  Name,
  selectedRoleId,
  selectedBaseLocation,
  disable
}) => {

  const customLocale = {
    emptyText: (<StyledButtons type="primary" className="m-3" onClick={() => setOpenModal(true)}>
      {Name}
    </StyledButtons>),
  };

  return (
    <>
      <Table
        className="mb-3"
        dataSource={tabledata}
        columns={columns}
        rowKey="role_id"
        pagination={false}
        locale={customLocale}
      />
      <div className="text-end w-100">
        <StyledButtonCancel onClick={() => setStep(step - 1)} className="mx-2">
          Back
        </StyledButtonCancel>
        {submit ? (
          <StyledButton  onClick={() => setCreate(true)}>Create</StyledButton>
        ) : (
          <StyledButton
            
            disabled={selectedRoleId?.length === 0 || selectedBaseLocation === "" || disable}
            onClick={() => setStep(step + 1)}
          >
            Next
          </StyledButton>
        )}
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  roleList: getRoleList(state),
});
export default connect(mapStateToProps, null)(SelectTable);